import { styled } from '@mui/system';
import { theme } from 'oems/theme';

export const Wrapper = styled('div')``;

export const Title = styled('div')`
  font-weight: 700;
  font-size: 24px;
  line-height: 125%;
  color: ${theme.palette.text.dark};
  margin-bottom: 24px;

  .addInvoiceButton {
    margin-left: 24px;

    > button {
      padding-left: 12px;
      color: ${theme.palette.buttonText.main};

      svg {
        width: 20px;
        height: 20px;
        margin-right: 8px;
      }
    }
  }
`;

export const Buttons = styled('div')`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 24px;
  flex-wrap: wrap;
  margin-top: 24px;
`;

export const Box = styled('div')`
  background: #ffffff;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.17);
  border-radius: 12px;
  padding: 24px;
  height: 100%;
  overflow: auto;
`;

export const LayoutWrapper = styled('div')`
  .react-grid-layout {
    position: relative;
  }

  &.isEditing {
    border: 1px dashed ${theme.palette.border.light};

    .item {
      border: 1px dashed ${theme.palette.border.light};

      .deleteButton {
        position: absolute;
        top: 5px;
        right: 0;
        background: #ffffff50;
      }

      .react-resizable-handle-se {
        width: 10px;
        height: 10px;
        display: block;
        position: absolute;
        bottom: 6px;
        right: 6px;
        border-right: 2px solid black;
        border-bottom: 2px solid black;
      }
    }
  }
`;
